// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__X7jpy","rotation":"loader_rotation__ZEnPa"};